import type { SegmentProviderConfig } from '@openx/components-segment/lib/utils/context/SegmentContext.tsx';

import { useAccountOptionsFetch } from './utils/useAccountOptionsFetch.ts';
import { useCreateLookalikeSegment } from './utils/useCreateLookalikeSegment.ts';
import { useLalSegmentFetch } from './utils/useLalSegmentFetch.ts';
import { useLalSegmentPermissions } from './utils/useLalSegmentPermissions.ts';
import { useLalSegmentsListFetch } from './utils/useLalSegmentsListFetch.ts';
import { useLalSegmentsOperation } from './utils/useLalSegmentsOperation.ts';
import { useLalSegmentsWithDetails } from './utils/useLalSegmentsWithDetails.ts';
import { useLalSegmentsWithDetailsFetch } from './utils/useLalSegmentsWithDetailsFetch.ts';
import { useLalSegmentTableFetch } from './utils/useLalSegmentTableFetch.ts';
import { useProvidersListFetch } from './utils/useProvidersListFetch.ts';
import { useSegmentReachFetch } from './utils/useSegmentReachFetch.ts';
import { useSegmentsEstimatedReachFetch } from './utils/useSegmentsEstimatedReachFetch.ts';
import { useSegmentsInfinityScrollListFetch } from './utils/useSegmentsInfinityScrollListFetch.ts';
import { useSegmentsLinkedAudiences } from './utils/useSegmentsLinkedAudiences.ts';
import { useSegmentsLinkedAudiencesFetch } from './utils/useSegmentsLinkedAudiencesFetch.ts';
import { useSegmentsListFetch } from './utils/useSegmentsListFetch.ts';
import { useSegmentsOperation } from './utils/useSegmentsOperation.ts';
import { useSegmentTableFetch } from './utils/useSegmentTableFetch.ts';
import { useUpdateLookalikeSegment } from './utils/useUpdateLookalikeSegment.ts';
import { useUploadSegment } from './utils/useUploadSegment.ts';

export const segmentConfig: SegmentProviderConfig = {
  isOa: true,
  useAccountOptionsFetch,
  useSegmentReachFetch,
  useSegmentTableFetch,
  useSegmentsLinkedAudiences,
  useSegmentsLinkedAudiencesFetch,
  useSegmentsListFetch,
  useSegmentsOperation,
  useUploadSegment,
  useProvidersListFetch,
  useLalSegmentTableFetch,
  useLalSegmentsListFetch,
  useLalSegmentsOperation,
  useLalSegmentsWithDetails,
  useLalSegmentsWithDetailsFetch,
  useLalSegmentFetch,
  useCreateLookalikeSegment,
  useLalSegmentPermissions,
  useUpdateLookalikeSegment,
  useSegmentsEstimatedReachFetch,
  useSegmentsInfinityScrollListFetch,
};
